/** @prettier  */
import { Dispatch, SetStateAction, useCallback } from 'react';
import { useTimeout } from './useTimeout';

interface Props {
  setPlaying: Dispatch<SetStateAction<boolean>>;
  isPlaying: boolean;
  selectedSpotIds: string[];
  timeoutTime: number;
  hasCam: boolean;
}

/**
 * Create a cam timeout (default 5 mins), which pauses the cams and sets `timeout`
 * to true once the timeout has been reached
 */
export const useCamTimeout = ({
  setPlaying,
  isPlaying,
  selectedSpotIds,
  timeoutTime,
  hasCam,
}: Props) => {
  const doPause = useCallback(() => setPlaying(false), [setPlaying]);
  const triggers = [isPlaying, selectedSpotIds];
  const initialState = false;
  const [timeout, setTimeoutState] = useTimeout({
    timeoutLength: timeoutTime,
    triggers,
    initialState,
    cb: doPause,
    start: isPlaying && hasCam,
  });

  const resetTimeout = () => {
    setPlaying(true);
    setTimeoutState(false);
  };

  return [timeout, resetTimeout];
};

export default useCamTimeout;
